<template>
    <NavBar :bgcolor="entity.product.color">
        <template v-slot:title>
            <span class="nav-title">新华数藏·藏品详情</span>
        </template>
    </NavBar>
    <ShowCase class="show-case" :cover="entity.product.cover" :intensity="entity.product.intensity" :background="entity.product.background" :exhibition="entity.product.exhibition" :otherImages="entity.product.model_mapping" :productKey="entity.product.id"></ShowCase>
    <div class="shadow" v-if="! musics.length" :class="{xinhua: xinhua}" :style="`background: linear-gradient(${hexToRgb(entity.product.color, 0)} 0%, ${entity.product.color} 100%)`"></div>
    <img src="@/assets/images/play-big.png" class="play" :class="{xinhua: xinhua}" @click="togglePlayer" v-else>
    <div class="player" :style="`background: ${hexToRgb(entity.product.color, 0.95)}`" :class="{active: player, xinhua: xinhua}" v-if="musics.length">
        <div class="header">
            <img src="@/assets/images/player-retract.png" @click="togglePlayer">
            <img src="@/assets/images/player-share.png" @click="shareShow = true" v-if="xinhua">
        </div>
        <div class="swiper">
            <van-swipe @change="changeMusic" :show-indicators="false" ref="swiper">
                <van-swipe-item v-for="(music, index) in musics" :key="index">
                    <van-image :src="require('@/assets/images/vinyl-frame.png')" class="frame"/>
                    <van-image :src="require('@/assets/images/vinyl-plate.png')" class="plate" v-if="index == musicIndex" :style="{transform: `rotate(${plateRate}deg)`}"/>
                    <van-image :src="require('@/assets/images/vinyl-plate.png')" class="plate" v-else :style="{color: 'red'}"/>
                    <van-image :src="music.cover" class="cover"/>
                </van-swipe-item>
            </van-swipe>
        </div>
        <p class="name">{{ musics[musicIndex].name }}</p>
        <div class="indicators" v-if="musics.length > 1">
            <p v-for="(music, index) in musics" :key="index" class="item" :class="{active: index == musicIndex}"></p>
        </div>
        <div class="slider">
            <van-slider v-model="musicRate" bar-height="4px" active-color="white" inactive-color="rgba(255, 255, 255, 0.3)" button-size="17px" @drag-start="musicPlaying = false" @drag-end="musicPlaying = true"/>
            <div class="time">
                <span>{{ getTime(musicStart) }}</span>
                <span>{{ getTime(musicTotal) }}</span>
            </div>
            <audio :src="musics[musicIndex][musicQuality]" @timeupdate="musicUpdate" @canplay="initMusic" ref="music"></audio>
        </div>
        <div class="action">
            <div class="small"></div>
            <!-- <img src="@/assets/images/music-download.png" class="small" @click="musicDownload"> -->
            <img src="@/assets/images/music-prev.png" class="small" @click="changeMusic(musicIndex - 1, true)">
            <img src="@/assets/images/music-pause.png" class="big" v-show="musicPlaying" @click="musicPlaying = false">
            <img src="@/assets/images/music-play.png" class="big" v-show="! musicPlaying" @click="musicPlaying = true">
            <img src="@/assets/images/music-next.png" class="small" @click="changeMusic(musicIndex + 1, true)">
            <img src="@/assets/images/music-hd.png" class="small" v-show="musicQuality == 'hd'" @click="musicQualityShow = true">
            <img src="@/assets/images/music-perfect.png" class="small" v-show="musicQuality == 'perfect'" @click="musicQualityShow = true">
        </div>
        <van-popup :show="musicQualityShow" position="bottom">
            <div class="quality">
                <div class="top">
                    <span>选择音质</span>
                    <img src="@/assets/images/close-detail-toast.png" @click="musicQualityShow = false">
                </div>
                <div class="list">
                    <div class="item" @click="changeMusicQuality('hd')">
                        <img src="@/assets/images/music-hd-icon.png">
                        <p>高清</p>
                    </div>
                    <div class="item" @click="changeMusicQuality('perfect')">
                        <img src="@/assets/images/music-perfect-icon.png">
                        <p>无损</p>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
    <main class="bg-color" :style="{backgroundColor: entity.product.color}">
        <div class="heead-button">
            <div class="box" @click="downloadImage">
                <img src="@/assets/images/share.png" alt="" />
                <span>分享</span>
            </div>
            <router-link :to="'/product/' + entity.product.id + '/compose'" class="box" v-if="owner && entity.can_compose && ! entity.is_composed && entity.product.type == types.fragment">
                <img src="@/assets/images/he.png" alt=""/>
                <span>可合成</span>
            </router-link>
            <img src="@/assets/images/down.png" v-if="false" alt="" />
            <div class="box" v-if="owner && showDownload" @click="download">
                <img src="@/assets/images/down.png" alt="" />
                <span>保存作品</span>
            </div>
        </div>
        <div class="detail-box">
            <div class="name">{{ entity.product.name }}</div>
            <div class="xl-list" v-if="false">
                <div class="item" v-for="tag in entity.product.tags" :key="tag.name">{{ tag.name }}</div>
            </div>
        </div>
        <div class="cp-status">
            <div class="f-status">收藏者：{{ entity.user.name }}</div>
        </div>
        
        <div class="field-container">
            <div class="field-content">
                <div class="field">
                    <div class="field-ri czz-wrapper">
                        <div class="field-author author-desc">藏品编号：</div>
                        <div class="field-name author-name">#{{ entity.nft.number }}</div>
                    </div>
                    <div class="field-ri czz-wrapper">
                        <div class="field-author author-desc">藏品ID：</div>
                        <div class="field-name author-name">{{ entity.nft.bid }}</div>
                    </div>
                    <div class="field-ri">
                        <div class="field-author">创作者：</div>
                        <div class="field-name publisher-name">{{ entity.product.organization.name }}</div>
                    </div>
                    <div class="field-ri" v-if="entity.product.issuer_show">
                        <div class="field-author">发行方：</div>
                        <div class="field-name publisher-name">{{ entity.product.issuer.name }}</div>
                    </div>
                    <div class="field-ri">
                        <div class="field-author">收藏时间：</div>
                        <div class="field-name fx-date">{{ entity.created_at }}</div>
                    </div>
                    <div class="field-ri field-ri-end">
                        <div class="field-author">藏品价格：</div>
                        <div class="field-name publisher-name">{{ entity.product.price > 0 ? '¥ ' + entity.product.price : '限时免费' }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="tips-title-cp">{{ entity.product.price > 0 ? '购买须知' : '免费领取须知' }}</div>

        <div class="field-container">
            <div class="field-content">
                <div class="field tip" v-if="entity.product.price > 0">
                    数字藏品为虚拟商品，而非实物，在区块链上具备唯一性和稀缺性。商品一经售出，不支持退换，平台暂无转赠功能。购买前请先注册认证并登录平台，以保证藏品顺利发放至您的账户。用户不得将数字藏品用于任何商业用途。我们坚决抵制对数字藏品进行任何形式的价格炒作、场外交易、欺诈，或以任何非法方式进行使用。平台保留追究法律责任的权利。
                </div>
                <div class="field tip" v-else>
                    本次发布的数字藏品均为限量免费领取。所有作品一经领取，不支持退换，平台暂无转赠功能。领取前请先注册认证并登录平台，以保证藏品顺利发放至您的账户。用户不得将数字藏品用于任何商业用途。我们坚决抵制对数字藏品进行任何形式的价格炒作、场外交易、欺诈，或以任何非法方式进行使用。平台保留追究法律责任的权利。
                </div>
            </div>
        </div>

        <!-- 底层链技术 -->
        <img class="xhl-logo" src="@/assets/images/xhl-logo.png" alt="" />
    </main>
    <van-overlay :show="showWelfareAlert" class="success-overlay">
        <div class="unpack">
            <img src="@/assets/images/blindbox.png" class="blindbox">
            <p class="title">获得福利</p>
            <a href="javascript:;" class="button" @click="showWelfareAlert = false;showWelfareInfo = true;">打开福利</a>
            <img src="@/assets/images/close.png" class="close" @click="welfareIndex = welfareIndex + 1;showWelfareAlert = welfares.length > welfareIndex">
        </div>
    </van-overlay>
    <van-overlay :show="showWelfareInfo" class="success-overlay">
        <div class="welfare" v-if="! welfares[welfareIndex].code">
            <img src="@/assets/images/close.png" class="close" @click="showWelfareInfo = false;welfareIndex = welfareIndex + 1;showWelfareAlert = welfares.length > welfareIndex">
            <img :src="welfares[welfareIndex].cover" class="cover">
            <img src="@/assets/images/welfare_line.png" class="line">
            <p class="title">{{ welfares[welfareIndex].name }}</p>
            <p class="title">领取说明</p>
            <pre class="description">{{ welfares[welfareIndex].description }}</pre>
            <router-link :to="'/welfare/' + welfares[welfareIndex].id" class="button">填写联系方式</router-link>
        </div>
        <Redeem :id="welfares[welfareIndex].id"
                :code="welfares[welfareIndex].code"
                :platform="welfares[welfareIndex].use"
                @close="showWelfareInfo = false; welfareIndex = welfareIndex + 1; showWelfareAlert = welfares.length > welfareIndex"
                v-else>
        </Redeem>
    </van-overlay>

    <van-overlay :show="true" class="download" :class="{show: downloadShow}">
        <div class="preview" id="preview" :style="{backgroundColor: entity.product.color}">
            <img :src="entity.product.share_image || entity.product.cover" alt="" class="cover">
            <p class="number">藏品编号#{{ entity.nft.number }}</p>
            <div class="info">
                <p class="name">{{ entity.product.name }}</p>
                <div class="label">
                    <span>藏品ID：</span>
                    <span>{{ entity.nft.bid && entity.nft.bid.length > 20 ? entity.nft.bid.substr(0, 10) + '...' + entity.nft.bid.substr(-10) : entity.nft.bid }}</span>
                </div>
                <div class="label">
                    <span>发行方：</span>
                    <span>{{ entity.product.issuer.name }}</span>
                </div>
                <div class="label">
                    <span>收藏家：</span>
                    <span>{{ entity.user.name }}</span>
                </div>
                <div class="bottom">
                    <div class="logo-box">
                        <p class="skill"><span class="prefix">底层链技术：</span><span class="value">新华·星火链</span></p>
                        <img src="@/assets/images/logo.png" alt="" class="logo">
                    </div>
                    <div class="qrcode-box">
                        <img src="@/assets/images/qrcode.png" alt="" class="qrcode">
                        <div>
                            <p>参</p>
                            <p>与</p>
                            <p>并</p>
                            <p>领</p>
                            <p>取</p>
                            <p>藏</p>
                            <p>品</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <img :src="imageBase64" class="show" @touchstart="touchStart" @touchend="touchEnd">
        <p class="tip">长按图片保存到本地</p>
        <div class="box" v-if="false">
            <div class="item">
                <img src="@/assets/images/icon-wx.png" alt="" @click="shareShow = true">
                <span>微信</span>
            </div>
            <div class="item">
                <img src="@/assets/images/icon-pyq.png" alt="" @click="shareShow = true">
                <span>朋友圈</span>
            </div>
            <div class="item">
                <img src="@/assets/images/icon-qq.png" alt="" @click="shareShow = true">
                <span>QQ</span>
            </div>
            <div class="item">
                <img src="@/assets/images/icon-download.png" alt="">
                <span>保存本地</span>
            </div>
        </div>
        <img src="@/assets/images/close.png" alt="" class="close" @click="downloadShow = false">
    </van-overlay>
    <van-overlay :show="shareShow" class="share-guide" @click="shareShow = false">
        <img src="@/assets/images/guide-arrow.png" alt="">
        <div class="tip">
            <p class="title">立即分享给好友吧</p>
            <p class="subtitle">点击屏幕右上角将本页面分享给好友</p>
        </div>
    </van-overlay>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>